module.exports = __webpack_public_path__ + "img/369camera.7f446bdf(1).48073548.png";